const onElementLoaded = (elementSelector, oneTime = false, parentSelector, callback) => {
  return new Promise((resolve, reject) => {
    try {
      if (document.querySelector(elementSelector)) {
        resolve(true);
        return;
      }
      const parentEl = parentSelector ? document.querySelector(parentSelector) : document;
      const observer = new MutationObserver((_, observer) => {
        const targetEl = document.querySelector(elementSelector);
        if (targetEl) {
          if (oneTime) observer.disconnect();
          if (typeof callback === "function") {
            callback(targetEl);
          }
          resolve(true);
        }
      });
      observer.observe(parentEl, { childList: true, subtree: true });
    } catch (error) {
      reject(new Error("onElementLoaded: promise rejected"));
    }
  });
};

const pointCustomComponent = () => {
  const pointSelectors = {
    rootId: 'loyaltylion',
    header: 'div.lion-header',
    headerYourPoint: 'div.lion-header__your-points',
    headerYourPointValue: 'div.lion-header__your-points > span > strong',
    headerPendingPoint: 'div.lion-header__pending-points',
    headerNav: 'nav.lion-header__nav',
    rewardList: 'div.lion-rewards-list',
    rewardItem: 'div.lion-reward-item',
    rewardItemActions: 'div.lion-reward-item__actions',
    rewardClaimedItem: 'div.lion-claimed-reward-item',
    historyList: 'table.lion-history-table',
    modal: 'div.lion-modal',
    modalLoaded: 'div.lion-modal.lion-modal--custom',
    modalRedeemConfirmBox: 'div.lion-redeem-reward-modal__confirm-box',
    modalAfterRedeemSummary: 'div.lion-redeem-reward-modal__summary'
  };

  function formatDateToJapanese(element) {
    const text = element.textContent;
    const dateRegex = /(\d{4})\/(\d{1,2})\/(\d{1,2})/;
    
    const match = text.match(dateRegex);
    if (match) {
      const [, year, month, day] = match;
      return `クーポン有効期限: ${year}年${month}月${day}日`;
    }
    return text;
  }

  const initComponent = () => {
    setupEvent();
    watchForPostRedeemModal();
  };

  const watchForPostRedeemModal = () => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            const postRedeemMessage = node.querySelector && node.querySelector('.lion-redeem-reward-modal__expiration-message--post-redeem');
            if (postRedeemMessage) {
              setTimeout(() => {
                const contentEle = node.querySelector('.lion-redeem-reward-modal__content');
                if (contentEle && !contentEle.querySelector('.coupon-use-button')) {
                  addCouponUseButton(contentEle);
                }
              }, 300);
            }

            if (node.classList && node.classList.contains('lion-redeem-reward-modal__expiration-message--post-redeem')) {
              setTimeout(() => {
                const modal = document.querySelector('.lion-modal--custom');
                const contentEle = modal && modal.querySelector('.lion-redeem-reward-modal__content');
                if (contentEle && !contentEle.querySelector('.coupon-use-button')) {
                  addCouponUseButton(contentEle);
                }
              }, 300);
            }
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  };

  const setupEvent = () => {
    onElementLoaded(pointSelectors.rewardItemActions, true).then(() => {
      updateRewardListHtml();
      clickRewardList();
    }).catch(() => {});

    onElementLoaded(pointSelectors.rewardClaimedItem, true).then(() => {
      updateRewardClaimedListHtml();
    }).catch(() => {});

    onElementLoaded(pointSelectors.modal, false, null, (modal) => {
      if (!modal.classList.contains('lion-modal--custom')) {
        modal.classList.add('lion-modal--custom');
        handleFirstModalOpen(modal);
      } else {
        handleModalReopen(modal);
      }
    }).catch(() => {});

    onElementLoaded(pointSelectors.historyList, true).then(() => {
      updateHistoryListHtml();
    }).catch(() => {});
  };

  const handleFirstModalOpen = (modal) => {
    const rewardButtons = document.querySelectorAll('.lion-action-button.lion-redeem-reward-modal__button.lion-redeem-reward-modal__button--confirm');
    let originalButton = null;
    if (rewardButtons.length > 1) {
      originalButton = rewardButtons[1];
      originalButton.style.display = 'none';
    }
    if (modal.classList.contains('lion-redeem-reward-modal')) {
      updateRewardModalConfirmBoxHtml(originalButton);
    }
    if (modal.classList.contains('lion-modal--history-info')) {
      updateRewardModalCommentHtml();
    }
  };

  const handleModalReopen = (modal) => {
    const summary = modal.querySelector(pointSelectors.modalAfterRedeemSummary);
    if (summary && !summary.classList.contains('lion-redeem-reward-modal__summary-custom')) {
      summary.classList.add('lion-redeem-reward-modal__summary-custom');
      updateAfterRedeemModalSummaryHtml();
      updateHistoryListHtml();
    }

    const postRedeemMessage = modal.querySelector('.lion-redeem-reward-modal__expiration-message--post-redeem');
    if (postRedeemMessage) {
      setTimeout(() => {
        const contentEle = modal.querySelector('.lion-redeem-reward-modal__content');
        if (contentEle) {
          addCouponUseButton(contentEle);
        }
      }, 100);
    }
  };

  const updateRewardListHtml = () => {
    document.querySelectorAll(pointSelectors.rewardItem).forEach((item) => {
      const title = item.querySelector(".lion-reward-item__title")?.innerText || "";
      const yenNumber = extractDigits(title);
      const icon = item.querySelector(".lion-reward-item__icon");
      if (!icon) return;
      icon.innerHTML = getCouponElementByNumber(yenNumber);
      const buttonAction = item.querySelector("button.lion-action-button");
      if (buttonAction && buttonAction.classList.contains("lion-action-button--disabled")) {
        item.classList.add('is-disabled');
      }
    });
  };

  const clickRewardList = () => {
    document.querySelectorAll(pointSelectors.rewardItem).forEach((item) => {
      item.addEventListener('click', () => {
        const button = item.querySelector("button.lion-action-button");
        if (button && button.getAttribute('data-testid') === "redeem-reward-button" &&
            !button.classList.contains("lion-action-button--disabled")) {
          button.click();
        }
      });
    });
  };

  const updateRewardClaimedListHtml = () => {
    document.querySelectorAll(pointSelectors.rewardClaimedItem).forEach((item) => {
      const title = item.querySelector(".lion-claimed-reward-item__title")?.innerText || "";
      const yenNumber = extractDigits(title);
      const icon = item.querySelector(".lion-claimed-reward-item__icon");
      if (!icon) return;
      icon.innerHTML = getCouponElementByNumber(yenNumber);
    });
  };

  const updateRewardModalConfirmBoxHtml = (originalButton) => {
    const titleEl = document.querySelector(".lion-modal__title");
    if (!titleEl) return;

    const title = titleEl.innerText;
    const redeemAmount = extractDigits(title);
    const couponEl = getCouponElementByNumber(redeemAmount);

    titleEl.innerText += '割引クーポンに交換';
    const confirmButton = document.querySelector('.lion-action-button.lion-redeem-reward-modal__button.lion-redeem-reward-modal__button--confirm');
    if (confirmButton) confirmButton.innerText = '交換する';

    const imageEl = document.querySelector('.lion-redeem-reward-modal__minimum-spend');
    if (imageEl) {
      imageEl.innerHTML += `
      <div class="bg-custom-point">
        ${couponEl}
      </div>`;
    }

    const consumptionText = document.createElement('div');
    consumptionText.className = 'consumption-text';
    consumptionText.innerText = `（${redeemAmount}ポイント使用）`;
    consumptionText.style.cssText = "font-size: 16px; color: #1E1E1E; text-align: center;";
    titleEl.insertAdjacentElement('afterend', consumptionText);

    const buttonContainer = document.querySelector('.lion-redeem-reward-modal__button-container');
    if (buttonContainer) {
      const pElement = document.createElement('p');
      pElement.style.cssText = "text-align: left; font-size:12px; line-height: 1.83; color: #1E1E1E;";
      buttonContainer.insertBefore(pElement, buttonContainer.firstChild || null);

      const newDiv = document.createElement('div');
      newDiv.className = 'modal-button-container';
      const newButton = document.createElement('button');
      newButton.innerText = '交換する';
      newButton.className = 'lion-action-button custom-modal-open-button';
      newDiv.appendChild(newButton);
      buttonContainer.appendChild(newDiv);
    }

    insertBreadCrumbs();
    const modalWrapperDiv = document.createElement('div');
    const titleDiv = document.createElement('div');
    titleDiv.className = 'modal_page_title';
    titleDiv.innerText = 'クーポンに交換';
    modalWrapperDiv.insertAdjacentElement('afterbegin', titleDiv);
    modalWrapperDiv.classList.add('lion-modal__wrapper');
    const header = document.querySelector('.lion-modal__header');
    const content = document.querySelector('.lion-modal__content');
    if (header) modalWrapperDiv.appendChild(header);
    if (content) modalWrapperDiv.appendChild(content);

    const pointAmountEl = document.querySelector('.modal__point__amount');
    const pointTitleEl = document.querySelector('.modal__point__title');
    if (pointAmountEl) pointAmountEl.innerText = redeemAmount;
    if (pointTitleEl) pointTitleEl.innerText = title;
    const returnToMypageWrap = document.querySelector('.lion-modal .btn__return_to_mypage_wrap');
    if (returnToMypageWrap) {
      returnToMypageWrap.insertAdjacentElement('afterend', modalWrapperDiv);
    }

    const openBtn = document.querySelector('button.lion-action-button.custom-modal-open-button');
    if (openBtn) {
      modalContent();
    }

    const confirmBtn = document.querySelector('.lion-action-button.lion-redeem-reward-modal__button.lion-redeem-reward-modal__button--confirm');
    if (confirmBtn && originalButton) {
      confirmBtn.addEventListener('click', () => {
        const modalBg = document.querySelector('#confirmation-modal-bg');
        const modal = document.querySelector('#confirmation-modal-content');
        modal?.classList.remove('show');
        modalBg?.classList.remove('show');
        originalButton.click();

        setTimeout(() => {
          document.querySelector('.lion-redeem-reward-modal .lion-modal__content');
        }, 1000);
      });
    }
  };

  const insertBreadCrumbs = () => {
    const divWrapper = document.createElement('div');
    divWrapper.classList.add('btn__return_to_mypage_wrap');
    const div = document.createElement('div');
    div.classList.add('btn__return_to_mypage_inner');
    divWrapper.appendChild(div);
    const closeButton = document.querySelector('div.lion-modal--custom a.lion-modal__close-button');
    if (closeButton) {
      closeButton.classList.add('btn__return_to_mypage');
      closeButton.innerText = "マイページ / ポイント";
      div.appendChild(closeButton);
    }
    const lionModal = document.querySelector('.lion-modal');
    if (lionModal) {
      lionModal.insertAdjacentElement('afterbegin', divWrapper);
    }
  }

  const updateRewardModalCommentHtml = () => {
    const titleEl = document.querySelector(".lion-modal__title");
    if (!titleEl) return;
    const title = titleEl.innerText;
    const redeemAmount = extractDigits(title);
    const couponEl = getCouponElementByNumber(redeemAmount);

    let imageEl = document.querySelector('.lion-history-info-modal-content__comment-min-spend');
    if (!imageEl) {
      const newDiv = document.createElement('div');
      newDiv.className = 'lion-history-info-modal-content__comment-min-spend';
      const modalContent = document.querySelector('.lion-history-info-modal-content__comment');
      if (modalContent) modalContent.insertBefore(newDiv, modalContent.firstChild);
      imageEl = newDiv;
    }

    imageEl.innerHTML += `
      <div class="bg-custom-point">
        ${couponEl}
      </div>`;

    const contentEle = document.querySelector('div.lion-modal--custom .lion-history-info-modal-content');
    if (contentEle) {
      document.querySelector('.lion-copy-to-clipboard-button').innerHTML = 'コピー';
      const explainHtml = `
      <div class="lion-history-info-modal-content__explain-point">
        <p>クーポンの使用方法</p>
        <ol>
          <li>[コピー]ボタンをクリックしてクーポンコードをコピーします。</li>
          <li>このページの下部に使い方の詳細を記載しています。</li>
        </ol>
      </div>`;
      contentEle.innerHTML += explainHtml;
      const explainPointElement = contentEle.querySelector('.lion-history-info-modal-content__explain-point');
      const rewardCodeElement = contentEle.querySelector('.lion-reward-code');
      if (explainPointElement && rewardCodeElement) {
        rewardCodeElement.parentNode.insertBefore(explainPointElement, rewardCodeElement);
      }

      addCouponUseButton(contentEle);
    }
    insertBreadCrumbs();

    const modalWrapperDiv = document.createElement('div');
    const titleDiv = document.createElement('div');
    titleDiv.className = 'modal_page_title';
    titleDiv.innerText = 'クーポンに交換';
    modalWrapperDiv.insertAdjacentElement('afterbegin', titleDiv);
    modalWrapperDiv.classList.add('lion-modal__wrapper');
    const header = document.querySelector('.lion-modal__header');
    const content = document.querySelector('.lion-modal__content');
    if (header) modalWrapperDiv.appendChild(header);
    if (content) modalWrapperDiv.appendChild(content);
    const returnToMypageWrap = document.querySelector('.lion-modal .btn__return_to_mypage_wrap');
    if (returnToMypageWrap) {
      returnToMypageWrap.insertAdjacentElement('afterend', modalWrapperDiv);
    }
    titleEl.innerHTML = `<span>クーポンを獲得しました！</span>`;

    document.querySelectorAll('.lion-history-info-modal-content__comment-expiry').forEach(element => {
      element.textContent = formatDateToJapanese(element);
    });

    insertTermEl();
    removeLightScreen();
  };

  const updateAfterRedeemModalSummaryHtml = () => {
    const titleEl = document.querySelector(".lion-modal__title");
    if (!titleEl) return;
    const title = titleEl.innerText;
    const redeemAmount = extractDigits(title);
    const couponEl = getCouponElementByNumber(redeemAmount);
    const summaryEl = document.querySelector('.lion-redeem-reward-modal__summary-custom');
    if (!summaryEl) return;
    summaryEl.innerHTML = `
      <div class="lion-redeem-reward-modal__summary">
        <div class="lion-redeem-reward-modal__summary-bg">
          <div class="bg-custom-point">
            ${couponEl}
          </div>
        </div>
      </div>`;

    const contentEle = document.querySelector('div.lion-modal--custom .lion-redeem-reward-modal__content');
    if (contentEle) {
      document.querySelector('.lion-copy-to-clipboard-button').innerHTML = 'コピー';
      const explainHtml = `
      <div class="lion-history-info-modal-content__explain-point">
        <p>クーポンの使用方法</p>
        <ol>
          <li>[コピー]ボタンをクリックしてクーポンコードをコピーします。</li>
          <li>このページの下部に使い方の詳細を記載しています。</li>
        </ol>
      </div>`;
      contentEle.innerHTML += explainHtml;

      const expirationMessage = document.querySelector('.lion-redeem-reward-modal__expiration-message.lion-redeem-reward-modal__expiration-message--post-redeem');
      expirationMessage.textContent = formatDateToJapanese(expirationMessage);
      if (expirationMessage) {
        const summaryEl = document.querySelector('.lion-redeem-reward-modal__summary.lion-redeem-reward-modal__summary-custom');
        expirationMessage.remove();
        summaryEl.insertAdjacentElement('afterend', expirationMessage.cloneNode(true));
      }
      const explainPointElement = contentEle.querySelector('.lion-history-info-modal-content__explain-point');
      const rewardCodeElement = contentEle.querySelector('.lion-reward-code');
      if (explainPointElement && rewardCodeElement) {
        rewardCodeElement.parentNode.insertBefore(explainPointElement, rewardCodeElement);
      }

      setTimeout(() => {
        addCouponUseButton(contentEle);
      }, 200);
    }

    titleEl.innerHTML = `<span>クーポンを獲得しました！</span>`;
    const consumptionText = document.querySelector('.consumption-text');
    if (consumptionText) consumptionText.style.display = 'none';

    insertTermEl();
    removeLightScreen();
    updateRewardClaimedListHtml();
  };

  const insertTermEl = () => {
    const modal = document.querySelector('div.lion-modal--custom');
    if (modal) {
      const pointDescription = document.getElementById('point-description').cloneNode(true);
      pointDescription.style.display = 'block';
      modal.appendChild(pointDescription);
    }
  };

  const updateHistoryListHtml = () => {
    updatePointHistoryTable();
    const pagination = pointPaginationComponent();
    pagination.init();
  };

  const updatePointHistoryTable = () => {
    const table = document.querySelector('.lion-history-table');
    const tbody = table.querySelector('tbody');
    // 静的配列として行を取得
    let rows = Array.from(tbody.querySelectorAll('.lion-history-table__row'));

    // "reset" 行のインデックスを探す
    const resetIndex = rows.findIndex(row => {
      const thirdTd = row.querySelectorAll('td')[2];
      return thirdTd && thirdTd.innerText.trim() === 'reset';
    });

    // reset-pending 行のインデックスを探す
    const resetPendingIndex = rows.findIndex(row => {
      const thirdTd = row.querySelectorAll('td')[2];
      return thirdTd && thirdTd.innerText.trim() === 'reset-pending';
    });

    // system 行をすべて消す
    rows.forEach((row) => {
      const thirdTd = row.querySelectorAll('td')[2];
      if (thirdTd && thirdTd.innerText.trim() === 'system') {
        row.remove();
      }
    });

    if (resetIndex !== -1) {
      // reset行からそれ以降（古い履歴）を削除
      for (let i = resetIndex; i < rows.length; i++) {
        rows[i].remove();
      }
      // 削除後は再度残りの行を取得しなおす
      rows = Array.from(tbody.querySelectorAll('.lion-history-table__row'));
    }

    if (resetPendingIndex !== -1) {
      // reset-pending行を削除
      rows[resetPendingIndex].remove();
      // 削除後は再度残りの行を取得しなおす
      rows = Array.from(tbody.querySelectorAll('.lion-history-table__row'));
    }

    // 空履歴(empty state) があればメッセージ表示
    if (tbody.querySelectorAll('.lion-history-table__row-cell--empty-state').length > 0) {
      table.querySelector('.lion-history-table__row-cell--empty-state')
        .innerHTML = '<p>履歴はまだ有りません。</p>';
      return;
    }
    rows.forEach((row) => {
      if (row.querySelector('.lion-history-state-bubble--pending')) {
        row.remove();
        return;
      }
      const firstTd = row.querySelectorAll('td')[0];
      const thirdTd = row.querySelectorAll('td')[2];
      const formattedDate = getFormattedDate(firstTd.innerHTML);

      // 日付セル生成
      if (!firstTd.querySelector('.point-date')) {
        const div = document.createElement('div');
        div.classList.add('point-date');
        div.innerHTML = formattedDate;
        firstTd.innerHTML = '';
        firstTd.appendChild(div);
      }
      if (!firstTd.querySelector('.point-title')) {
        const span = document.createElement('span');
        span.classList.add('point-title');
        span.innerHTML = thirdTd.innerHTML;
        thirdTd.innerHTML = '';
        firstTd.appendChild(span);
      }
    });
  };


  const removeLightScreen = () =>
    document.querySelector('.lion-screen.lion-screen--light')?.remove();

  const getFormattedDate = (dateText) => {
    const date = new Date(dateText);
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // 0始まりなので +1 する
    const day = date.getDate();
    const monthStr = String(month).padStart(2, '0');
    const dayStr = String(day).padStart(2, '0');

    return `${year}年${monthStr}月${dayStr}日`;
  };

const extractDigits = (text) => {
    const digitsOnly = text.replace(/[^\d]/g, "");
    const num = parseInt(digitsOnly, 10);
    return isNaN(num) ? 0 : num;
  };

const getCouponElementByNumber = (number) => {
    switch (number) {
      case 100:   return '<div class="coupon-price-wrapper black"><div class="coupon-price">¥100</div><div class="off-wrapper">OFF</div></div>';
      case 200:   return '<div class="coupon-price-wrapper black"><div class="coupon-price">¥200</div><div class="off-wrapper">OFF</div></div>';
      case 300:   return '<div class="coupon-price-wrapper black"><div class="coupon-price">¥300</div><div class="off-wrapper">OFF</div></div>';
      case 400:   return '<div class="coupon-price-wrapper black"><div class="coupon-price">¥400</div><div class="off-wrapper">OFF</div></div>';
      case 500:   return '<div class="coupon-price-wrapper black"><div class="coupon-price">¥500</div><div class="off-wrapper">OFF</div></div>';
      case 600:   return '<div class="coupon-price-wrapper black"><div class="coupon-price">¥600</div><div class="off-wrapper">OFF</div></div>';
      case 800:   return '<div class="coupon-price-wrapper black"><div class="coupon-price">¥800</div><div class="off-wrapper">OFF</div></div>';
      case 1000:  return '<div class="coupon-price-wrapper bronze"><div class="coupon-price">¥1,000</div><div class="off-wrapper">OFF</div></div>';
      case 2000:  return '<div class="coupon-price-wrapper silver"><div class="coupon-price">¥2,000</div><div class="off-wrapper">OFF</div></div>';
      case 3000:  return '<div class="coupon-price-wrapper gold"><div class="coupon-price">¥3,000</div><div class="off-wrapper">OFF</div></div>';
      default:    return '';
    }
  };

  const addCouponUseButton = (contentEle) => {
    if (contentEle.querySelector('.coupon-use-button')) return;

    const pointTopElement = document.querySelector('.point-top');
    const customerTagsElement = document.getElementById('customerTags');

    let customerTags = '';
    let subscriptionIds = '';

    if (pointTopElement) {
      customerTags = pointTopElement.getAttribute('data-customer-tags') || '';
      subscriptionIds = pointTopElement.getAttribute('data-subscription-ids') || '';
    } else if (customerTagsElement) {
      customerTags = customerTagsElement.getAttribute('data-customer-tags') || '';
      const subscriptionIdsElement = document.getElementById('subscriptionIds');
      subscriptionIds = subscriptionIdsElement ? subscriptionIdsElement.getAttribute('data-subscription-ids') : '';
    }

    if (!subscriptionIds) {
      return;
    }

    const hasMigrationTag = customerTags.includes('migration:');
    const buttonText = hasMigrationTag ? 'きれい定期便に使う' : 'きれい継続コースに使う';

    const button = document.createElement('a');
    button.className = 'coupon-use-button';
    button.textContent = buttonText;

    const firstSubscriptionId = subscriptionIds.split(',')[0];
    if (firstSubscriptionId) {
      button.href = `/account?hbSubscriptionPath=%2Fsubscriptions%2Fgid%253A%252F%252Fshopify%252FSubscriptionContract%252F${firstSubscriptionId}?scroll=coupon`;
    } else {
      return;
    }

    const rewardCodeElement = contentEle.querySelector('.lion-reward-code');
    if (rewardCodeElement) {
      rewardCodeElement.insertAdjacentElement('afterend', button);

      const explainPointElement = contentEle.querySelector('.lion-history-info-modal-content__explain-point');
      if (explainPointElement) {
        button.insertAdjacentElement('afterend', explainPointElement);
      }
    }
  };

  return {
    init: initComponent
  };
};

const pointPaginationComponent = () => {
  const renderContainer = document.querySelector('.loyaltylion-history__pagination-wrapper');
  const paginationNumbers = document.getElementById("pagination-numbers");
  const paginatedList = document.querySelector(".loyaltylion-history__table #loyaltylion .lion-history-table tbody");
  let listItems = paginatedList?.querySelectorAll(".lion-history-table__row") || [];
  [...listItems].slice(30).forEach((item) => item.remove());
  listItems = paginatedList?.querySelectorAll(".lion-history-table__row") || [];
  const nextButton = document.getElementById("next-button");
  const prevButton = document.getElementById("prev-button");
  nextButton.innerHTML = '';
  prevButton.innerHTML = '';
  const paginationLimit = 5;
  const pageCount = Math.ceil(listItems.length / paginationLimit);
  let currentPage = 1;

  const disableButton = (button) => {
    button?.classList.add("disabled");
    button?.setAttribute("disabled", true);
  };
  const enableButton = (button) => {
    button?.classList.remove("disabled");
    button?.removeAttribute("disabled");
  };

  const handlePageButtonsStatus = () => {
    if (currentPage === 1) {
      disableButton(prevButton);
    } else {
      enableButton(prevButton);
    }
    if (pageCount === currentPage) {
      disableButton(nextButton);
    } else {
      enableButton(nextButton);
    }
  };

  const handleActivePageNumber = () => {
    document.querySelectorAll(".custom-pagination-number").forEach((button) => {
      button.classList.remove("active");
      if (Number(button.getAttribute("data-page-index")) === currentPage) {
        button.classList.add("active");
      }
    });
  };

  const appendPageNumber = (index) => {
    const pageNumber = document.createElement("button");
    pageNumber.className = "custom-pagination-number";
    pageNumber.innerHTML = index;
    pageNumber.setAttribute("data-page-index", index);
    pageNumber.setAttribute("aria-label", "Page " + index);
    paginationNumbers?.appendChild(pageNumber);
  };

  const handleShortPaginationDisplay = () => {
    const currentBtn = document.querySelector(".custom-pagination-number.active");
    paginationNumbers.innerHTML = "";
    const pageIndex = Number(currentBtn.getAttribute("data-page-index"));
    const nextPage = pageIndex + 1;
    const prevPage = pageIndex - 1;
    appendPageNumber(1);

    if (prevPage === 2) {
      appendPageNumber(prevPage);
    } else if (pageIndex - 1 > 2) {
      appendPageNumber('...');
      appendPageNumber(prevPage);
    }

    if (pageIndex !== 1) {
      appendPageNumber(pageIndex);
    }

    if ((pageCount - pageIndex) === 2) {
      appendPageNumber(nextPage);
    } else if ((pageCount - pageIndex) > 2) {
      appendPageNumber(nextPage);
      appendPageNumber('...');
    }

    if (pageIndex !== pageCount) {
      appendPageNumber(pageCount);
    }

    document.querySelectorAll(".custom-pagination-number").forEach((btn) => {
      const clickPage = btn.getAttribute("data-page-index");
      if (clickPage === '...') return;
      btn.addEventListener("click", () => {
        setCurrentPage(Number(clickPage));
      });
      if (Number(clickPage) === pageIndex) {
        btn.classList.add("active");
      }
    });
  };

  const getPaginationNumbers = () => {
    for (let i = 1; i <= pageCount; i++) {
      appendPageNumber(i);
    }
  };

  const setCurrentPage = (pageNum) => {
    currentPage = pageNum;
    handleActivePageNumber();
    handlePageButtonsStatus();
    handleShortPaginationDisplay();
    const prevRange = (pageNum - 1) * paginationLimit;
    const currRange = pageNum * paginationLimit;
    listItems.forEach((item, index) => {
      item.classList.add("is-hidden");
      if (index >= prevRange && index < currRange) {
        item.classList.remove("is-hidden");
      }
    });
  };

  const init = () => {
    if (!paginationNumbers || listItems.length === 0) return;
    getPaginationNumbers();
    setCurrentPage(1);
    prevButton?.addEventListener("click", () => setCurrentPage(currentPage - 1));
    nextButton?.addEventListener("click", () => setCurrentPage(currentPage + 1));
    if (pageCount <= 1 && renderContainer) {
      renderContainer.classList.add('is-hidden');
    }
  };

  return {
    init
  };
};

const modalContent = () => {
  const openModalButton = document.querySelector('.custom-modal-open-button');
  const modalBg = document.getElementById('confirmation-modal-bg');
  const modalEl = document.getElementById('confirmation-modal-content');
  const closeModalButton = document.getElementById('confirmation-modal-close');

  if (openModalButton) {
    openModalButton.addEventListener('click', () => {
      modalBg?.classList.add('show');
      modalEl?.classList.add('show');
    });
  }
  if (closeModalButton) {
    closeModalButton.addEventListener('click', () => {
      modalBg?.classList.remove('show');
      modalEl?.classList.remove('show');
    });
  }
  window.addEventListener('click', (event) => {
    if (event.target === modalBg) {
      modalBg?.classList.remove('show');
      modalEl?.classList.remove('show');
    }
  });
};

document.addEventListener('click', (event) => {
  if (event.target.classList.contains('lion-reward-code__clipboard-button')) {
    const codeEl = event.target.previousElementSibling;
    if (codeEl && codeEl.classList.contains('lion-reward-code__code')) {
      const codeText = codeEl.innerText;
      copyToClipboard(codeText);
      alert('クーポンコードがコピーされました: ' + codeText);
    }
  }
});

const copyToClipboard = text => {
  navigator.clipboard.writeText(text)
};

window.addEventListener('DOMContentLoaded', () => {
  const pointComponent = pointCustomComponent();
  pointComponent.init();
});

window.onload = () => {
  setTimeout(() => {
    const coupons = document.querySelectorAll('.lion-claimed-reward-item--approved');
    const howToUseCoupon = document.querySelector('.how-to-use-coupon-wrapper');
    if (!coupons || !howToUseCoupon) return;
    coupons.forEach((coupon) => {
      coupon.addEventListener('click', () => {
        const clone = howToUseCoupon.cloneNode(true);
        setTimeout(() => {
          const couponModal = document.querySelector('.lion-modal--history-info .lion-modal__content');
          if (couponModal && clone) {
            couponModal.parentNode.insertBefore(clone, couponModal.nextSibling);
            clone.style.display = 'block';
          }
        }, 1000);
      });
    });
  }, 1500);
};
